var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"yellow_icon",attrs:{"src":`${_vm.icon_path}${_vm.icon}`,"alt":"small icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }